import { render } from "./MainPageDateSelector.vue?vue&type=template&id=0f94af1e&scoped=true&ts=true"
import script from "./MainPageDateSelector.vue?vue&type=script&lang=ts"
export * from "./MainPageDateSelector.vue?vue&type=script&lang=ts"

import "./MainPageDateSelector.vue?vue&type=style&index=0&id=0f94af1e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f94af1e"]])

export default __exports__